import instance from "./ApiConfig.tsx";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../global/config/Action/loadingActions.ts";
import store from "../../global/config/store.ts"; 
export const baseApiCall = async (config) => {
  store.dispatch(setLoadingTrue());
  try {
    const response = await instance(config);

    if (response?.status >= 200 && response?.status < 300) {  
      return response?.data; 
    } else {
      // store.dispatch(setLoadingFalse());
      throw new Error(`Unexpected status code: ${response?.status}`);
    }
  } catch (e:any) {
    console.log('API error', e);
    if (e?.response?.status === 401) {
      setTimeout(() => {
        localStorage.clear();
        window.location.href = "/login";
        return;
      }, 1000);
    }
    const errorMessage = e?.response?.data?.message || "An error occurred while making the request.";
    store.dispatch(setLoadingFalse());
    // console.log("errorMessage errorMessage",errorMessage)
    // throw new Error(errorMessage);
    throw errorMessage
  
  }
  finally{
      store.dispatch(setLoadingFalse());
  }
};
